import styled from "styled-components"

const HomeContainer = styled.div<{ noMargin?: boolean }>`
  width: 800px;
  max-width: calc(100% - 48px);
  margin: ${props => (props.noMargin ? "0px" : "64px")} auto;
`

export default HomeContainer
